import {Form, Input} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {forwardRef, useImperativeHandle} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';

import {FORM_TEXTS} from '../../model/constants';
import {IBlockReasonsProps, IBlockReasonsFormRef, IBLockReasonsFormFields} from '../../model/types';
import styles from './block-user-button.module.less';

export const BlockReasonsForm = forwardRef<IBlockReasonsFormRef, IBlockReasonsProps>(
    ({reasonsRadioButtonData}: IBlockReasonsProps, ref) => {
        const [form] = useForm<IBLockReasonsFormFields>();

        useImperativeHandle(ref, () => ({
            getValues: async (): Promise<IBLockReasonsFormFields> => {
                await form.validateFields();
                return form.getFieldsValue();
            },
            validate: async (): Promise<void> => {
                await form.validateFields();
            },
            reset: (): void => {
                form.resetFields();
            },
        }));

        const selectEntries = reasonsRadioButtonData.map(({id: value, description: label}) => ({value, label}));

        const customSelectChanged = (id: number) => {
            const searchItem = reasonsRadioButtonData.find((item) => item.id === id);
            form.setFieldsValue({autoUnlocking: searchItem?.attribute1});
        };

        return (
            <>
                <h4>{FORM_TEXTS.TITLE}</h4>
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        name="reasonId"
                        rules={[{required: true, message: FORM_TEXTS.REASON_REQUIRED}]}
                        className={styles['block-reasons-form__item']}
                    >
                        <CustomSelect
                            entries={selectEntries}
                            onChange={customSelectChanged}
                            settings={{showSearch: true, isClearable: true, placeholder: FORM_TEXTS.REASON_PLACEHOLDER}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="autoUnlocking"
                        hidden
                    />
                    <Form.Item
                        name="comment"
                        label="Комментарий"
                        className={styles['block-reasons-form__item']}
                    >
                        <Input.TextArea placeholder={FORM_TEXTS.COMMENT_PLACEHOLDER} />
                    </Form.Item>
                </Form>
                <h4>{FORM_TEXTS.CONFIRM}</h4>
            </>
        );
    }
);

BlockReasonsForm.displayName = 'BlockReasonsForm';
